import { FCWithChildren } from '@types';
import React from 'react';

import activeIcon from '@assets/images/connected-status-icon.png';
import activeIconDark from '@assets/images/connected-status-icon-dark.svg';
import disconnectedIcon from '@assets/images/disconnected-status-icon.png';
import disconnectedIconDark from '@assets/images/disconnected-status-icon-dark.svg';
import inactiveIcon from '@assets/images/inactive-status-icon.png';
import inactiveIconDark from '@assets/images/inactive-status-icon-dark.svg';
import quarantinedIcon from '@assets/images/quarantined-status-icon.png';
import notOnNetworkIcon from '@assets/images/not-on-network-status-icon.png';
import notOnNetworkIconDark from '@assets/images/not-on-network-status-icon-dark.svg';

type StatusLedProps = {
  dataTip?: boolean;
  dataFor?: string;
  type: string;
};

type Status =
  | 'active'
  | 'Online'
  | 'disconnected'
  | 'inactive'
  | 'Offline'
  | 'quarantined'
  | 'unknown';

type IconEntry = { dark: string; invertDark?: never } | { dark?: never; invertDark: true };

const ICON_TYPES: Record<Status, { light: string } & IconEntry> = {
  active: { light: activeIcon, dark: activeIconDark },
  Online: { light: activeIcon, dark: activeIconDark },
  disconnected: { light: disconnectedIcon, dark: disconnectedIconDark },
  inactive: { light: inactiveIcon, dark: inactiveIconDark },
  Offline: { light: inactiveIcon, dark: inactiveIconDark },
  quarantined: { light: quarantinedIcon, invertDark: true },
  unknown: { light: notOnNetworkIcon, dark: notOnNetworkIconDark },
};

const StatusLed: FCWithChildren<StatusLedProps> = ({ dataTip, dataFor, type }) => {
  const props = {
    'data-tip': dataTip,
    'data-for': dataFor,
  };

  const entry = ICON_TYPES[type as Status];
  const { light } = entry;

  return (
    <div className="flex justify-center items-center w-6 h-6 mr-2" {...props}>
      {'dark' in entry && entry.dark ? (
        <>
          <img alt={type} src={light} className="dark:hidden" />
          <img alt={type} src={entry.dark} className="hidden dark:block" />
        </>
      ) : (
        <img alt={type} src={light} className={'invertDark' in entry ? 'dark:invert' : ''} />
      )}
    </div>
  );
};

export default StatusLed;
